var LocationDataTestIdEnum = /* @__PURE__ */ ((LocationDataTestIdEnum2) => {
  LocationDataTestIdEnum2["LOCATION_RESULT_OPTION"] = "result-location--option";
  LocationDataTestIdEnum2["LOCATION_RESULT_SEARCH"] = "location-search-results";
  LocationDataTestIdEnum2["LOCATION_RECENT_SEARCHED_RESULTS"] = "recent-searched-results";
  LocationDataTestIdEnum2["LOCATION_RECENT_SEARCHED_RESULTS_CLEAR"] = "recent-searched-results-clear";
  LocationDataTestIdEnum2["LOCATION_RECENT_SEARCHED_RESULTS_CONTAINER"] = "recent-searched-results-container";
  LocationDataTestIdEnum2["LOCATION_SELECTION_MODAL"] = "location-selection-modal";
  LocationDataTestIdEnum2["LOCATION_SELECTION_MODAL_CLOSE_BUTTON"] = "location-selection-modal-close-button";
  LocationDataTestIdEnum2["LOCATION_INITIAL_SUGGESTIONS"] = "location-initial-suggestions";
  LocationDataTestIdEnum2["CLOSE_MODAL_BUTTON"] = "close-modal-button--content-modal";
  return LocationDataTestIdEnum2;
})(LocationDataTestIdEnum || {});
export {
  LocationDataTestIdEnum
};
